import React from 'react';
import ImageHeader from '../components/Common/ImageHeader';
import Contents from '../components/CaseStudiesDetails/ContentsWithFilter';
import { useNavigate } from 'react-router-dom';
import { useCaseStudies, useCaseStudiesByCategory } from '../hooks/useCaseStudies';

const CaseStudies = () => {
  const navigate = useNavigate();
  
  // Get all case studies without any filters
  const { caseStudies, loading, error } = useCaseStudies();

  const handleBreadcrumbClick = (href) => {
    if (href && href !== "#") {
      navigate(href);
    }
  };
  return (
    <>
      <ImageHeader
        title="Case Studies"
        backgroundImage="/png/case_study.png"
        subtitle={"Discover how our solutions have transformed organizations and delivered measurable results."}
        breadcrumbItems={[
          { label: "Home", href: "/" }, 
          { label: "Case Studies", href: "#", isCurrentPage: true },
        ]}
        onBreadcrumbClick={handleBreadcrumbClick}
      />
      <Contents 
        caseStudies={caseStudies}
        loading={loading}
        error={error}
      />
    </>
  );
};

export default CaseStudies;